export default{
    data() {
        return {yearList:[]};
    },
    methods:{
        dealYear(year) {
            let yearNum = year;
            if (!yearNum) {
                yearNum = 3;
            }
            const list = [];
            const _year = new Date().getFullYear();
            for (let i = 0; i < yearNum; i++) {
                const result = Number(_year) - i;
                list.push({
                    name:result,
                    code:result.toString()
                });
            }
            this.yearList = list;
        }
    }
};
